import { useEffect, useRef, useState } from "react";
import { TitleBar } from "../../components/TitleBar";
import { CustomTabs } from "../../components/CustomTabs";
import useAuth from "../../hook/useAuth";
import { AddCourse } from "../../components/AddCourse";
import { delete_Course, getCourseByUser, put_Course } from "../../services/Course";
import { useNavigate } from "react-router-dom";
import { PleasewaitPopup } from "../../components/PleasewaitPopup";
import { EditCoursePopup } from "../../components/EditCoursePopup";
import DeletePopup from "../../components/DeletePopup";
import useDelete from "../../hook/useDelete";
import useConfirm from "../../hook/useConfirm";
import { ConfirmPopup } from "../../components/ConfirmPopup";

const tabs = ["In Progress", "Published"];

export const ContributorDashboard = () => {
    const { auth }: any = useAuth();
    const navigate = useNavigate();
    const { setDeletePopup, setData: setDeleteData }: any = useDelete();
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [showAddCoursePopup, setShowAddCoursePopup] = useState<boolean>(false);
    const [refreshInProgressCourseList, setRefreshInProgressCourseList] = useState<boolean>(true);
    const [showEditCoursePopup, setShowEditCoursePopup] = useState<boolean>(false);
    const [editCourse, setEditCourse] = useState<any>({});
    const [allInProgressCourse, setAllInProgressCourse] = useState<any[]>([]);
    const [inProgressCourseDataIsLoaded, setInProgressCourseDataIsLoaded] = useState<boolean>(false);
    const [refreshPublishedCourseList, setRefreshPublishedCourseList] = useState<boolean>(true);
    const [allPublishedCourse, setAllPublishedCourse] = useState<any[]>([]);
    const [publishedCourseDataIsLoaded, setPublishedCourseDataIsLoaded] = useState<boolean>(false);
    const [courseRefresh, setCourseRefresh] = useState<boolean>(false);
    const [dropdownOpen, setDropdownOpen] = useState<number | null>(null);
    const dropDownRefs = useRef<(HTMLDivElement | null)[]>([]);
    const [showPleasewait, setShowPleasewait] = useState<boolean>(false);

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (
                dropdownOpen !== null &&
                dropDownRefs.current[dropdownOpen] &&
                !dropDownRefs.current[dropdownOpen]?.contains(event.target as Node)
            ) {
                setDropdownOpen(null);
            }
        }

        document.addEventListener("click", handleClickOutside); // 👈 use click, not mousedown
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, [dropdownOpen]);

    const hanbleTabChange = (index: number) => {
        setActiveIndex(index);
        if (index === 0) {
            setRefreshInProgressCourseList(true);
            setAllInProgressCourse([]);
            setDropdownOpen(null);
        }
        else if (index === 1) {
            setRefreshPublishedCourseList(true);
            setAllPublishedCourse([]);
            setDropdownOpen(null);
        }
    }

    useEffect(() => {
        if (activeIndex === 0) {
            setRefreshInProgressCourseList(true);
            setCourseRefresh(false);
        }
        else {
            setRefreshPublishedCourseList(true);
            setCourseRefresh(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [courseRefresh])

    useEffect(() => {
        if (auth?.id && refreshInProgressCourseList && activeIndex === 0) {
            setInProgressCourseDataIsLoaded(false);
            getCourseByUser(auth?.id, false)
                .then((data) => {
                    setAllInProgressCourse(data);
                    setRefreshInProgressCourseList(false);
                    setInProgressCourseDataIsLoaded(true);
                    setEditCourse({});
                })
                .catch((error) => {
                    console.error(error);
                })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auth, refreshInProgressCourseList, activeIndex])

    useEffect(() => {
        if (auth?.id && refreshPublishedCourseList && activeIndex === 1) {
            setPublishedCourseDataIsLoaded(false);
            getCourseByUser(auth?.id, true)
                .then((data) => {
                    setAllPublishedCourse(data);
                    setRefreshPublishedCourseList(false);
                    setPublishedCourseDataIsLoaded(true);
                })
                .catch((error) => {
                    console.error(error);
                })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auth, refreshPublishedCourseList, activeIndex])

    const handleOnPublishCourse = (data: any) => {
        if (data) {
            setShowPleasewait(true);
            put_Course({
                ...data,
                isPublished: true,
                updatedAt: new Date().toLocaleString(),
                updatedBy: auth?.givenname
            }, auth?.id)
                .then((res) => {
                    setShowPleasewait(false);
                    setRefreshInProgressCourseList(true);
                })
                .catch((error) => {
                    console.error(error);
                })
        }
    }

    const handleOnUnpublishCourse = (data: any) => {
        if (data) {
            setShowPleasewait(true);
            put_Course({
                ...data,
                isPublished: false,
                updatedAt: new Date().toLocaleString(),
                updatedBy: auth?.givenname
            }, auth?.id)
                .then((res) => {
                    setShowPleasewait(false);
                    setRefreshPublishedCourseList(true);
                })
                .catch((error) => {
                    console.error(error);
                })
        }
    }

    const handleOnDeleteInprogressCourse = (id: number) => {
        if (id) {
            setDeletePopup(true);
            setDeleteData({
                id: id,
                tilte: `Delete`,
                summary: `Are you sure you want to delete this course?`,
                isDelete: (callback: any) => {
                    delete_Course(id, auth?.id)
                        .then(() => {
                            setDeletePopup(false);
                            setRefreshInProgressCourseList(true);
                            callback();
                        })
                        .catch(error => {
                            console.log(error);
                            callback();

                            setConfirmData({
                                title: 'Warning',
                                summary: error.response.data,
                                confirmBtn: 'Ok',
                                isConfirm: (callback: any) => {
                                    callback();
                                }
                            });

                            setConfirmPopup(true);
                        });
                }
            });
        }
    }

    const handleOnDeletePublishCourse = (id: number) => {
        if (id) {
            setDeletePopup(true);
            setDeleteData({
                id: id,
                tilte: `Delete`,
                summary: `Are you sure you want to delete this course?`,
                isDelete: (callback: any) => {
                    delete_Course(id, auth?.id)
                        .then(() => {
                            setDeletePopup(false);
                            setRefreshPublishedCourseList(true);
                            callback();
                        })
                        .catch(error => {
                            console.log(error);
                            callback();

                            setConfirmData({
                                title: 'Warning',
                                summary: error.response.data,
                                confirmBtn: 'Ok',
                                isConfirm: (callback: any) => {
                                    callback();
                                }
                            });

                            setConfirmPopup(true);
                        });
                }
            });
        }
    }

    return (
        <>
            <div className="p-4 min-h-screen">
                <TitleBar
                    title={"Welcome, " + auth?.givenname}
                    subTitle="Contributor Dashboard"
                />

                <div className="w-full py-8">
                    <CustomTabs
                        tabs={tabs}
                        activeIndex={activeIndex}
                        onChange={(index) => hanbleTabChange(index)}
                    />

                    {
                        activeIndex === 0 && (
                            <div className="w-full">
                                <div className="w-full mt-4 flex justify-end items-center">
                                    <button
                                        className="py-2 px-4 bg-primary text-white text-sm font-medium rounded-md outline-none hover:bg-blue-600 shadow-md"
                                        onClick={() => setShowAddCoursePopup(true)}
                                    >
                                        Create a course
                                    </button>
                                </div>

                                <div className="space-y-4 p-8">
                                    {
                                        allInProgressCourse?.map((item: any, index: number) => (
                                            <div key={index} className="md:flex items-center justify-between bg-white shadow rounded-lg p-4 border hover:shadow-md transition">
                                                <div className="flex items-center space-x-4">

                                                    <img src="/images/class-img.png" alt="class-img" className="w-16 h-16 rounded-md" />



                                                    <div>
                                                        <h3 className="font-semibold text-gray-800 uppercase">{item?.title}</h3>
                                                        <span className="text-sm font-medium text-red-500">{item?.courseCategoryName}</span>{" "}
                                                        <p className="text-sm text-gray-500">
                                                            {item?.description}
                                                        </p>
                                                    </div>
                                                </div>


                                                <div className="flex items-center space-x-3 max-md:w-full max-md:mt-2">
                                                    <button
                                                        className="max-md:w-full px-4 py-2 border rounded-md text-primary border-primary hover:bg-blue-50"
                                                        onClick={() => handleOnPublishCourse(item)}
                                                    >
                                                        Publish
                                                    </button>
                                                    <div ref={(el) => (dropDownRefs.current[index] = el)} className="relative">

                                                        <button className="text-gray-600 hover:text-gray-800" onClick={() => setDropdownOpen(dropdownOpen === index ? null : index)}>
                                                            <span className="material-symbols-outlined text-xl">
                                                                more_horiz
                                                            </span>
                                                        </button>

                                                        {dropdownOpen === index && (
                                                            <div className="absolute w-40 bg-white shadow-lg border rounded-md top-[42px] -right-[53px] z-[1000]">
                                                                <ul className="text-sm text-gray-700">
                                                                    <li
                                                                        className="px-4 py-2 hover:bg-gray-100 hover:underline cursor-pointer"
                                                                        onClick={() => navigate("/contributor/edit-course", { state: { id: item?.id, title: item?.title } })}
                                                                    >
                                                                        Update course
                                                                    </li>

                                                                    <li
                                                                        className="px-4 py-2 hover:bg-gray-100 hover:underline cursor-pointer"
                                                                        onClick={() => {
                                                                            setEditCourse(item);
                                                                            setShowEditCoursePopup(true);
                                                                        }}
                                                                    >
                                                                        Edit
                                                                    </li>

                                                                    <li
                                                                        className="px-4 py-2 hover:bg-gray-100 hover:underline cursor-pointer"
                                                                        onClick={() => handleOnDeleteInprogressCourse(item?.id)}
                                                                    >
                                                                        Delete
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>

                                {
                                    !inProgressCourseDataIsLoaded && (
                                        <div className="flex items-center justify-center w-full p-2">
                                            <div className="mb-4 h-12 w-12 animate-spin rounded-full border-4 border-gray-300 border-t-primary" />
                                        </div>
                                    )
                                }

                                {
                                    (inProgressCourseDataIsLoaded && allInProgressCourse.length === 0) && (
                                        <div className="flex items-center justify-center w-full p-2">
                                            <span className="text-lg text-gray-400">No course found!</span>
                                        </div>
                                    )
                                }
                            </div>
                        )
                    }


                    {
                        activeIndex === 1 && (
                            <div className="w-full">
                                {
                                    (publishedCourseDataIsLoaded && allPublishedCourse.length > 0) && (
                                        <div className="space-y-4 p-8">
                                            {
                                                allPublishedCourse?.map((item: any, index: number) => (
                                                    <div key={index} className="md:flex items-center justify-between bg-white shadow rounded-lg p-4 border hover:shadow-md transition">
                                                        <div className="flex items-center space-x-4">

                                                            <img src="/images/class-img.png" alt="class-img" className="w-16 h-16 rounded-md" />



                                                            <div>
                                                                <h2 className="font-semibold text-gray-800 uppercase">{item?.title}</h2>
                                                                <span className="text-sm font-medium text-red-500">{item?.courseCategoryName}</span>{" "}
                                                                <p className="text-sm text-gray-500">
                                                                    {item?.description}
                                                                </p>
                                                            </div>
                                                        </div>


                                                        <div className="flex items-center space-x-3 max-md:mt-2">
                                                            <button
                                                                className="max-md:w-full px-4 py-2 border rounded-md text-primary border-primary hover:bg-blue-50"
                                                                onClick={() => {
                                                                    setConfirmPopup(true);
                                                                    setConfirmData({
                                                                        title: "Are you sure to unpublish this course",
                                                                        confirmBtn: "Ok",
                                                                        isCancelBtn: true,
                                                                        isConfirm: (callback: any) => {
                                                                            handleOnUnpublishCourse(item)
                                                                            callback();
                                                                        }
                                                                    })
                                                                }}
                                                            >
                                                                Unpublish
                                                            </button>

                                                            <div ref={(el) => (dropDownRefs.current[index] = el)} className="relative">

                                                                <button className="text-gray-600 hover:text-gray-800" onClick={() => setDropdownOpen(dropdownOpen === index ? null : index)}>
                                                                    <span className="material-symbols-outlined text-xl">
                                                                        more_horiz
                                                                    </span>
                                                                </button>

                                                                {dropdownOpen === index && (
                                                                    <div className="absolute w-40 bg-white shadow-lg border rounded-md top-[42px] -right-[53px] z-[1000]">
                                                                        <ul className="text-sm text-gray-700">
                                                                            <li
                                                                                className="px-4 py-2 hover:bg-gray-100 hover:underline cursor-pointer"
                                                                                onClick={() => navigate("/contributor/edit-course", { state: { id: item?.id, title: item?.title } })}
                                                                            >
                                                                                Update course
                                                                            </li>

                                                                            <li
                                                                                className="px-4 py-2 hover:bg-gray-100 hover:underline cursor-pointer"
                                                                                onClick={() => {
                                                                                    setEditCourse(item);
                                                                                    setShowEditCoursePopup(true);
                                                                                }}
                                                                            >
                                                                                Edit
                                                                            </li>
                                                                            <li
                                                                                className="px-4 py-2 hover:bg-gray-100 hover:underline cursor-pointer"
                                                                                onClick={() => handleOnDeletePublishCourse(item?.id)}
                                                                            >
                                                                                Delete
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    )
                                }


                                {
                                    !publishedCourseDataIsLoaded && (
                                        <div className="flex items-center justify-center w-full p-2">
                                            <div className="mb-4 h-12 w-12 animate-spin rounded-full border-4 border-gray-300 border-t-primary" />
                                        </div>
                                    )
                                }

                                {
                                    (publishedCourseDataIsLoaded && allPublishedCourse.length === 0) && (
                                        <div className="flex items-center justify-center w-full p-2">
                                            <span className="text-lg text-gray-400">No course found!</span>
                                        </div>
                                    )
                                }
                            </div>
                        )
                    }


                </div>
            </div>

            {
                showAddCoursePopup && (
                    <AddCourse showPopup={showAddCoursePopup} setShowPopup={setShowAddCoursePopup} setRefreshCourseList={setRefreshInProgressCourseList} />
                )
            }

            {
                showEditCoursePopup && (
                    <EditCoursePopup showPopup={showEditCoursePopup} setShowPopup={setShowEditCoursePopup} setRefreshCourseList={setCourseRefresh} data={editCourse} />
                )
            }

            <DeletePopup />
            <ConfirmPopup />

            <PleasewaitPopup showPopup={showPleasewait} />
        </>

    )
}